export default __webpack_public_path__ + "static/media/2.cd4e4bb6.jpg";